export const enum RootPath {
    ADMIN = "/admin/home",
    AUTH = "/auth/sign-in"
}

// Coach landing lives in routes/access.ts (`landingPathForRole`), derived
// from the coach allowlist so the two can't drift apart.

export const layouts = ["/admin", "/auth"] as const;
export type Layout = typeof layouts[number];

// `requiresOrgFeature`: when set, the route is only shown in the sidebar if
// the currently-selected organization has the named boolean flag = true.
// Keeps feature-gated sidebar entries out of the way for tenants that don't
// use the feature. Evaluated in components/sidebar/components/Links.tsx.
export type OrgFeatureFlag = 'gameBookingCodeEnabled';

export type RType = RoutesType & {
    hidden?: boolean;
    layout: Layout;
    requiresOrgFeature?: OrgFeatureFlag;
    // Platform-staff tooling: only shown in the sidebar to elevated admins
    // (`GET organizations/is-elevated-admin`). Hiding is cosmetic — the page
    // and the API both enforce it.
    requiresElevatedAdmin?: boolean;
    // Extra paths that should keep this sidebar item highlighted. Useful for
    // detail pages that live on a sibling path (e.g. `/courtDetails`) rather
    // than under the list path (`/courts/:id`), which the matcher can't infer.
    activePaths?: string[];
};
